import axios from "axios";

import {
  settings as commonSettings,
  initCommonSettings,
} from "@krea/customer-features/settings";
import { useCustomerFeaturesSettingsStore } from "@krea/customer-features/store/app-settings/useCustomerFeaturesSettingsStore";
import type { AppSettingsProps } from "@krea/customer-features/types/settings";
import { config } from "@krea/shared/config";
import type { CountryCode } from "@krea/shared/types/common";

// only init/merge common settings once
let mergedSettings: AppSettingsProps | undefined;
if (!mergedSettings) {
  mergedSettings = initCommonSettings({
    environment: config.environment,
    backendBaseUrl: config.apiRootUrl,
  });
}
const settings = mergedSettings;

const getCustomerWebUrl = (): string =>
  config.appUrls(useCustomerFeaturesSettingsStore.getState().countryCode)
    .customer;

export const setCountryCode = (countryCode: CountryCode) => {
  const changeCountryCode =
    useCustomerFeaturesSettingsStore.getState().setCountryCode;

  changeCountryCode(countryCode);

  const customerWebUrl = getCustomerWebUrl();

  settings.customerWebUrl = customerWebUrl;
  commonSettings.customerWebUrl = customerWebUrl;
};

// Set global axios config
axios.defaults.baseURL = settings.backendBaseUrl;
axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default settings;
